import { render, staticRenderFns } from "./ProductionHeader.vue?vue&type=template&id=21754c66&scoped=true"
import script from "./ProductionHeader.vue?vue&type=script&lang=js"
export * from "./ProductionHeader.vue?vue&type=script&lang=js"
import style0 from "./ProductionHeader.vue?vue&type=style&index=0&id=21754c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21754c66",
  null
  
)

export default component.exports